import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip/Tooltip';
import { useSnackbar } from 'notistack';
import { JSONSchema7 } from 'json-schema';
import { v4 as uuidv4 } from 'uuid';
import * as _ from "lodash";
import PageState from '../../Shared/pageState';
import savePageSchema from '../../Controls/savePageSchema';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import ControlState from '../../Shared/controlState';
import { WorkflowEngineActionKind, WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import { useContext, MouseEvent } from 'react';



export default ({ control }: { control: ControlState }) => {
    const { state, dispatch } = useContext(WorkflowEngineContext);
    const { enqueueSnackbar } = useSnackbar();
    const { pages } = state;
    const changeControlIds = (newControl: ControlState, pageId: string) => {

        newControl.id = `control-${uuidv4()}`;
        const schemaId = `#${pageId}/${newControl.id}`;

        const newSchema = newControl.schema as JSONSchema7;
        newSchema.$id = schemaId;

        const newSchemaProps = newSchema.properties as JSONSchema7Properties;

        // Change ids on each custom props
        for (const keyProp in newSchemaProps) {
            newSchemaProps[keyProp].$id = `${schemaId}/${keyProp}`;
            if (keyProp === `id`) {
                newSchemaProps[keyProp].default = `${uuidv4().replace(/-/g, '')}`;
            }
        }
        newControl.pageId = pageId;
        return newControl;
    };
    const handleCopyClick = async (ev: MouseEvent<HTMLButtonElement>) => {
        ev.preventDefault();
        ev.stopPropagation();
        let duplicateControl = _.cloneDeep(control);

        const lastPage = pages[pages.length - 1] as PageState;
        duplicateControl = changeControlIds(
            duplicateControl,
            lastPage.id
        );
        dispatch({
            type: WorkflowEngineActionKind.CONTROL_ADD,
            payload: duplicateControl
        });
        await savePageSchema(
            lastPage.id,
            JSON.stringify(lastPage.schema),
            enqueueSnackbar
        );
        enqueueSnackbar('Component has been successfully copied', {
            variant: 'success'
        });
    };


    return (
        <Tooltip title="Duplicate" followCursor>
            <IconButton aria-label="Copy"
                size="small"
                onClick={handleCopyClick}>
                <ContentCopyIcon fontSize="small" />
            </IconButton>
        </Tooltip>
    );
};
